import React, { Component } from 'react';
import iconSprite from '../../assets/icon-sprite.svg';

export default React.forwardRef(({ children, onClick }, ref) => (
  <svg
    width="20"
    height="20"
    className="more-icon"
    id="dropdown1"
    data-toggle="dropdown"
    aria-haspopup="true"
    aria-expanded="false"
    ref={ref}
    onKeyDown={() => { }}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}>
    <use xlinkHref={iconSprite + '#more-icon'}></use>
  </svg>
));
